import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ReturnInputsProps {
  annualizedReturn: string;
  projectedAnnualizedReturn: string;
  onAnnualizedReturnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onProjectedAnnualizedReturnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ReturnInputs = ({
  annualizedReturn,
  projectedAnnualizedReturn,
  onAnnualizedReturnChange,
  onProjectedAnnualizedReturnChange
}: ReturnInputsProps) => {
  return (
    <div className="bg-gray-50 rounded-lg p-4">
      <div className="bg-navy/10 p-4 rounded-lg border border-navy/20 space-y-4">
        <div>
          <Label htmlFor="annualizedReturn" className="text-navy-dark font-semibold block mb-2">
            Annualized Return (%)
          </Label>
          <Input
            id="annualizedReturn"
            type="text"
            value={annualizedReturn}
            onChange={onAnnualizedReturnChange}
            className="max-w-[200px]"
            placeholder="0.00"
          />
        </div>

        <div>
          <Label htmlFor="projectedAnnualizedReturn" className="text-navy-dark font-semibold block mb-2">
            Projected Annualized Return (%)
          </Label>
          <Input
            id="projectedAnnualizedReturn"
            type="text"
            value={projectedAnnualizedReturn}
            onChange={onProjectedAnnualizedReturnChange}
            className="max-w-[200px]"
            placeholder="0.00"
          />
        </div>
      </div>
    </div>
  );
};

export default ReturnInputs;